<template>
  <div id="app" :style="{minWidth: minWidth + 'px'}">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      minWidth: 1200
    }
  },
  mounted () {
    let userAgentInfo = navigator.userAgent
    let Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod")
    for (let i = 0; i < Agents.length; i++) {
      if (userAgentInfo.indexOf(Agents[i]) > 0) {
        this.minWidth = 0
        break
      }
    }
  }
}
</script>

<style>
#app {
  min-width: 11.667rem;
  overflow: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 0;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue